import { SquadFormState } from '../types/squad';

export function toSquadFormState(
  promiseData: any,
  productEntityRef: string,
): SquadFormState {
  const { spec, metadata } = promiseData;
  return {
    squad_owner: {
      mail: spec.team_structure.owner.email,
    },
    squad_owner_role: spec.team_structure.owner.role,
    'delta-squad':
      metadata.labels?.['ax.accessacloud.com/delta-squad'] === 'true' || false,
    squad_members: spec.team_structure.members.map((member: any) => ({
      role: member.role,
      value: {
        name: member.name.toLowerCase().replace(/ /g, '.'),
        email: member.email,
        userId: '', // This would need to be fetched from another source
        displayName: member.name,
        entityRef: `user:default/${member.name
          .toLowerCase()
          .replace(/ /g, '.')}`,
      },
    })),
    squad_name: spec.name,
    squad_product: productEntityRef,
    squad_sw_company: spec.sw_company
      ? `domain:default/${spec.sw_company}`
      : '',
  };
}
